import { Radar } from "react-chartjs-2";

function RadarChart(props) {
  return <Radar data={props.data} />;
}

export default RadarChart;
